import { CameraOutlined, DeleteOutlined, EditOutlined } from '@vindr/icons';
import { Form, Space, Upload } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface UploadItemProps {
  form: FormInstance<any>;
  name?: string;
  placeholder?: string;
  editItem?: any;
  noStyle?: boolean;
  [key: string]: any;
}

const UploadItem = ({
  name = 'logo',
  placeholder = 'Upload Logo',
  form,
  editItem,
  noStyle,
  ...props
}: UploadItemProps) => {
  const { t } = useTranslation('Vindoc');
  const image = Form.useWatch(name, form);

  return (
    <Form.Item name={name} noStyle={noStyle}>
      <Upload
        accept="image/*"
        listType="picture-card"
        fileList={[]}
        action={image}
        customRequest={(data) => data.onSuccess('ok')}
        beforeUpload={(file) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const logo = e.target.result;
            // setImage(logo);
            form.setFieldValue(name, logo);
          };
          reader.readAsDataURL(file);
        }}
        {...props}
        // onPreview={handlePreview}
        // onChange={(data) => console.log(data)}
      >
        {image ? (
          <div className="relative">
            <img src={image} alt={image} style={{ width: '100%' }} />
            <div
              className="overlay text-white"
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                display: 'flex',
                background: 'rgba(0,0,0,0.5)',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: 16,
                transition: 'all 0.3s',
                top: 0,
                left: 0,
              }}
            >
              <Space size="middle">
                <EditOutlined className="image-action" />
                <DeleteOutlined
                  className="image-action"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // setImage('');
                    form.setFieldsValue({ [name]: null });
                  }}
                />
              </Space>
            </div>
          </div>
        ) : (
          <div className="signature-text" style={{ opacity: 0.4 }}>
            <div style={{ marginTop: 8 }}>{t(placeholder)}</div>
            <CameraOutlined style={{ fontSize: 20 }} />
          </div>
        )}
      </Upload>
    </Form.Item>
  );
};
export default UploadItem;
